/**
 * The URL of the Smart Filter snippet server
 */
export const SnippetUrl = "https://snippet.babylonjs.com";
